import axios from 'axios';
import { store } from 'index';
import constants from '../../config/constants';
// import { PrismicClient } from "../../config/prismicClient";
import { setLoggedUserUtils } from '../../utils/commonFunc';
// import { ref, storage } from "config/firebaseConfig";

export const USER_LOGGED_IN = 'ADMIN_LOGGED_IN';
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT';

export const SHOW_TOAST = 'SHOW_TOAST';
export const CLOSE_TOAST = 'CLOSE_TOAST';

export const GET_USER_PROFILE = 'GET_USER_PROFILE';

export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export const SET_VISITED_COURSE_ID = 'SET_VISITED_COURSE_ID';

// Common
export const SET_COMMON_STORE_PARAM = 'SET_COMMON_STORE_PARAM';

// Notification system
export const showToast = (message, errorType) => {
  return {
    type: SHOW_TOAST,
    message,
    errorType,
  };
};

export const closeToast = () => ({
  type: CLOSE_TOAST,
});

//= ========== Reducer call functions begin ===========//
export const userLoggedIn = user => ({
  type: USER_LOGGED_IN,
  user,
});

export const userLoggedOut = () => ({
  type: USER_LOGGED_OUT,
});

export const getUserProfile = userProfile => ({
  type: GET_USER_PROFILE,
  userProfile,
});

// Active tab and tab courseId
export const setStoreActiveTab = activeTab => {
  return {
    type: SET_ACTIVE_TAB,
    activeTab,
  };
};

export const setVisitedCourseId = visitData => {
  return {
    type: SET_VISITED_COURSE_ID,
    activeTab: visitData.activeTab,
    courseId: visitData.courseId,
  };
};

export const setCommonParam = (paramName, value) => {
  store.dispatch({
    type: SET_COMMON_STORE_PARAM,
    paramName,
    value,
  });
};
//= ========== Reducer call functions begin ===========//

//= ========== User routing begin ===========//
export const validateUserLoggedIn = user => dispatch => {
  dispatch(userLoggedIn(user));
  // axios.post("/api/auth/validateUserLoggedIn", { user })
  // .catch(err => {
  //   localStorage.removeItem("loggedUser");
  //   dispatch(userLoggedOut());
  // })
};

export const login = credentials => async dispatch => {
  const res = await axios.post(`${constants.API_BASE_URL}/api/auth/signin`, credentials);
  setLoggedUserUtils({ ...res.data });
  dispatch(userLoggedIn(res.data));
  // const prismic = await PrismicClient.query('', { pageSize: 100 });
  // console.error({prismic});
  return res.data;
};

export const logout = () => dispatch => {
  dispatch(userLoggedOut());
  localStorage.clear();
};

// axios.interceptors.request.use(request => {
//   console.error('Starting Request......', JSON.stringify(request.url, null, 2));
//   return request;
// });

// axios.interceptors.response.use(response => {
//   console.error('Response:......', JSON.stringify(response.config.url, null, 2));
//   return response;
// });

export const fetchUserService = data => async dispatch => {
  let url = '';
  if (data.userRole === constants.roles.teacher) {
    url = `/api/employee/get-employee/${data.userId}`;
  } else if (data.userRole === constants.roles.admin) {
    url = `/api/admin/get-school-admin/${data.userId}`;
  }
  try {
    const res = await axios.get(constants.API_BASE_URL + url, constants.setHeader(data.token));
    dispatch(getUserProfile(res.data));
  } catch (err) {
    console.error('Err-fetchUserService', err?.response);
  }
};

export const updateUserService = data => async () => {
  let url = '';
  if (data.userRole === constants.roles.teacher) {
    url = `/api/employee/update-employee/${data.userId}`;
  } else if (data.userRole === constants.roles.admin) {
    url = `/api/admin/update-school-admin/${data.userId}`;
  }
  try {
    await axios.put(constants.API_BASE_URL + url, data.postData, constants.setHeader(data.token));
  } catch (err) {
    console.error('Err-updateUserService', err?.response);
  }
};

export const updatePasswordService = data => () => {
  return axios.post(
    `${constants.API_BASE_URL}/api/auth/change-password`,
    data.passwordData,
    constants.setHeader(data.token)
  );
};

//= ========== User routing end ===========//
